// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LeftPanel */

.left-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

.panel-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.3px;
}

/* Textarea block grows to fill available panel space */
.textarea-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1;
  min-height: 0;
}

.conversation-textarea {
  width: 100%;
  flex: 1 1;
  min-height: 200px;
  padding: 14px 16px;
  background: #0a0a0a;
  border: 1.5px solid #333333;
  border-radius: 10px;
  color: #ffffff;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.65;
  resize: vertical;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
  box-sizing: border-box;
}

.conversation-textarea::placeholder { color: #666666; }

.conversation-textarea:focus {
  border-color: #ffffff;
  background: #111111;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);
}

.conversation-textarea:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  resize: none;
}

.conversation-textarea::-webkit-scrollbar { width: 5px; }
.conversation-textarea::-webkit-scrollbar-track { background: transparent; }
.conversation-textarea::-webkit-scrollbar-thumb { background: #444444; border-radius: 3px; }

/* Char count row */
.char-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.char-count {
  font-size: 11px;
  color: #999999;
  white-space: nowrap;
  flex-shrink: 0;
}

.progress-track {
  flex: 1 1;
  height: 3px;
  background: #2a2a2a;
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #ffffff;
  border-radius: 2px;
  transition: width 0.25s ease, background 0.25s;
}

.progress-fill.warning {
  background: linear-gradient(90deg, #e05555, #ff7b7b);
}

/* Inline messages */
.inline-error {
  padding: 10px 14px;
  background: rgba(224, 85, 85, 0.1);
  border: 1px solid rgba(224, 85, 85, 0.35);
  border-radius: 7px;
  color: #ff8a8a;
  font-size: 13px;
  line-height: 1.5;
}

.inline-hint {
  font-size: 12px;
  color: #999999;
  padding: 0 2px;
}

/* Action row */
.action-row {
  display: flex;
  gap: 10px;
}

.btn-generate,
.btn-clear {
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-generate {
  flex: 1 1;
  background: #ffffff;
  color: #000000;
  box-shadow: 0 3px 12px rgba(255, 255, 255, 0.18);
}

.btn-generate:hover:not(:disabled) {
  background: #e6e6e6;
  box-shadow: 0 5px 18px rgba(255, 255, 255, 0.28);
  transform: translateY(-1px);
}

.btn-generate:active:not(:disabled) { transform: translateY(0); }

.btn-generate:disabled {
  background: #2a2a2a;
  color: #777777;
  cursor: not-allowed;
  box-shadow: none;
}

.btn-generate.loading {
  background: #e6e6e6;
  cursor: wait;
}

.btn-clear {
  padding: 12px 18px;
  background: #0a0a0a;
  color: #999999;
  border: 1.5px solid #333333;
}

.btn-clear:hover:not(:disabled) {
  background: #1a1a1a;
  border-color: #ffffff;
  color: #ffffff;
}

.btn-clear:disabled { opacity: 0.4; cursor: not-allowed; }

/* Spinner — sits on the (now white) loading button, so it's dark-on-light */
.btn-spinner {
  display: inline-block;
  width: 13px;
  height: 13px;
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-top-color: #000;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
  flex-shrink: 0;
}

@keyframes spin { to { transform: rotate(360deg); } }

/* "His last messages" stepper */
.his-last-n {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 6px 0 12px;
}

.his-last-n-label {
  font-size: 0.82rem;
  color: #b3a7bd;
  font-weight: 500;
}

.his-last-n-steps { display: inline-flex; gap: 6px; }

.his-last-n-step {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  border: 1.5px solid #322b38;
  background: #0e0a12;
  color: #b3a7bd;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.13s ease;
}
.his-last-n-step:hover:not(:disabled) { border-color: #c084fc; color: #c084fc; }
.his-last-n-step.active {
  background: #c084fc;
  border-color: #c084fc;
  color: #ffffff;
  box-shadow: 0 3px 12px rgba(192, 132, 252, 0.3);
}
.his-last-n-step:disabled { cursor: not-allowed; opacity: 0.5; }

/* Mobile */
@media (max-width: 768px) {
  .conversation-textarea { min-height: 160px; }
  .action-row { flex-direction: column; }
  .btn-clear { padding: 11px 18px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/LeftPanel.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA,sCAAsC,cAAc,EAAE;;AAEtD;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,4CAA4C,UAAU,EAAE;AACxD,kDAAkD,uBAAuB,EAAE;AAC3E,kDAAkD,mBAAmB,EAAE,kBAAkB,EAAE;;AAE3F,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,oDAAoD;AACtD;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kCAAkC;EAClC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA,sCAAsC,wBAAwB,EAAE;;AAEhE;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,sBAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD,4EAA4E;AAC5E;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB,oBAAoB,EAAE,QAAQ,EAAE;;AAEpD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;AACA,wCAAwC,qBAAqB,EAAE,cAAc,EAAE;AAC/E;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,+CAA+C;AACjD;AACA,4BAA4B,mBAAmB,EAAE,YAAY,EAAE;;AAE/D,WAAW;AACX;EACE,yBAAyB,iBAAiB,EAAE;EAC5C,cAAc,sBAAsB,EAAE;EACtC,aAAa,kBAAkB,EAAE;AACnC","sourcesContent":["/* LeftPanel */\n\n.left-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-height: 0;\n}\n\n.panel-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.3px;\n}\n\n/* Textarea block grows to fill available panel space */\n.textarea-block {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  min-height: 0;\n}\n\n.conversation-textarea {\n  width: 100%;\n  flex: 1;\n  min-height: 200px;\n  padding: 14px 16px;\n  background: #0a0a0a;\n  border: 1.5px solid #333333;\n  border-radius: 10px;\n  color: #ffffff;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.65;\n  resize: vertical;\n  outline: none;\n  transition: border-color 0.2s, background 0.2s;\n  box-sizing: border-box;\n}\n\n.conversation-textarea::placeholder { color: #666666; }\n\n.conversation-textarea:focus {\n  border-color: #ffffff;\n  background: #111111;\n  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.1);\n}\n\n.conversation-textarea:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  resize: none;\n}\n\n.conversation-textarea::-webkit-scrollbar { width: 5px; }\n.conversation-textarea::-webkit-scrollbar-track { background: transparent; }\n.conversation-textarea::-webkit-scrollbar-thumb { background: #444444; border-radius: 3px; }\n\n/* Char count row */\n.char-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.char-count {\n  font-size: 11px;\n  color: #999999;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.progress-track {\n  flex: 1;\n  height: 3px;\n  background: #2a2a2a;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: #ffffff;\n  border-radius: 2px;\n  transition: width 0.25s ease, background 0.25s;\n}\n\n.progress-fill.warning {\n  background: linear-gradient(90deg, #e05555, #ff7b7b);\n}\n\n/* Inline messages */\n.inline-error {\n  padding: 10px 14px;\n  background: rgba(224, 85, 85, 0.1);\n  border: 1px solid rgba(224, 85, 85, 0.35);\n  border-radius: 7px;\n  color: #ff8a8a;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.inline-hint {\n  font-size: 12px;\n  color: #999999;\n  padding: 0 2px;\n}\n\n/* Action row */\n.action-row {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-generate,\n.btn-clear {\n  padding: 12px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.btn-generate {\n  flex: 1;\n  background: #ffffff;\n  color: #000000;\n  box-shadow: 0 3px 12px rgba(255, 255, 255, 0.18);\n}\n\n.btn-generate:hover:not(:disabled) {\n  background: #e6e6e6;\n  box-shadow: 0 5px 18px rgba(255, 255, 255, 0.28);\n  transform: translateY(-1px);\n}\n\n.btn-generate:active:not(:disabled) { transform: translateY(0); }\n\n.btn-generate:disabled {\n  background: #2a2a2a;\n  color: #777777;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.btn-generate.loading {\n  background: #e6e6e6;\n  cursor: wait;\n}\n\n.btn-clear {\n  padding: 12px 18px;\n  background: #0a0a0a;\n  color: #999999;\n  border: 1.5px solid #333333;\n}\n\n.btn-clear:hover:not(:disabled) {\n  background: #1a1a1a;\n  border-color: #ffffff;\n  color: #ffffff;\n}\n\n.btn-clear:disabled { opacity: 0.4; cursor: not-allowed; }\n\n/* Spinner — sits on the (now white) loading button, so it's dark-on-light */\n.btn-spinner {\n  display: inline-block;\n  width: 13px;\n  height: 13px;\n  border: 2px solid rgba(0, 0, 0, 0.2);\n  border-top-color: #000;\n  border-radius: 50%;\n  animation: spin 0.75s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* \"His last messages\" stepper */\n.his-last-n {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 6px 0 12px;\n}\n\n.his-last-n-label {\n  font-size: 0.82rem;\n  color: #b3a7bd;\n  font-weight: 500;\n}\n\n.his-last-n-steps { display: inline-flex; gap: 6px; }\n\n.his-last-n-step {\n  width: 32px;\n  height: 32px;\n  border-radius: 9px;\n  border: 1.5px solid #322b38;\n  background: #0e0a12;\n  color: #b3a7bd;\n  font-weight: 700;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.13s ease;\n}\n.his-last-n-step:hover:not(:disabled) { border-color: #c084fc; color: #c084fc; }\n.his-last-n-step.active {\n  background: #c084fc;\n  border-color: #c084fc;\n  color: #ffffff;\n  box-shadow: 0 3px 12px rgba(192, 132, 252, 0.3);\n}\n.his-last-n-step:disabled { cursor: not-allowed; opacity: 0.5; }\n\n/* Mobile */\n@media (max-width: 768px) {\n  .conversation-textarea { min-height: 160px; }\n  .action-row { flex-direction: column; }\n  .btn-clear { padding: 11px 18px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
